<template>
  <div class="contactus">
    <v-container>
      <v-row>
        <v-col cols="6">
          <div class="contactus-info">
            <div class="item-contactus-info">
              <div class="info-icon">
                <v-icon>mdi-email-open</v-icon>
              </div>
              <div class="info-text">
                <h5 class="font-weight-bold">{{oracle.translate('ایمیل:')}}</h5>
                <div style="display: grid">
                  <span>info@cluna.app</span>
                  <span>info@cluna.ir</span>
                </div>
              </div>
            </div>
            <div style="visibility: hidden" class="item-contactus-info">
              <div class="info-icon">
                <v-icon>place</v-icon>
              </div>
              <div class="info-text">
                <h5 class="font-weight-bold">{{oracle.translate('آدرس:')}}</h5>
                <span>
                  {{oracle.translate('کیلومتر ۱۷ جاده مخصوص، بعد از خیابان داروپخش، خیابان ۶۳، بن بست چهارم، پلاک 11')}}
                </span>
              </div>
            </div>
            <div style="visibility: hidden" class="item-contactus-info">
              <div class="info-icon">
                <v-icon>mdi-phone</v-icon>
              </div>
              <div class="info-text">
                <h5 class="font-weight-bold">{{oracle.translate('تلفن:')}}</h5>
                <span>{{oracle.translate('۰۲۱-۴۴۹۹۵۲۹۶')}}</span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="6">
          <div class="contactus-form">
            <v-container>
              <v-col cols="12">
                <div class="fieldProfile-contact">
                  <label>{{oracle.translate('نام و نام خانوادگی:')}}</label>
                  <v-text-field
                      v-model="name"
                      dir="ltr"
                      solo
                      hide-details
                      :placeholder="oracle.translate('نام و نام خانوادگی')"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="fieldProfile-contact">
                  <label>{{oracle.translate('شماره تماس:')}}</label>
                  <v-text-field
                      v-model="number"
                      dir="ltr"
                      solo
                      hide-details
                      :placeholder="oracle.translate('شماره تماس')"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="fieldProfile-contact">
                  <label>{{oracle.translate('عنوان پیام:')}}</label>
                  <v-text-field
                      v-model="title"
                      dir="ltr"
                      solo
                      hide-details
                      :placeholder="oracle.translate('عنوان پیام')"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12">
                <div class="fieldProfile-contact">
                  <label>{{oracle.translate('متن پیام:')}}</label>
                  <v-textarea
                      v-model="note"
                      dir="ltr"
                      name="input-7-4"
                      hide-details
                      solo
                      :placeholder="oracle.translate('متن پیام')"
                  ></v-textarea>
                </div>
              </v-col>
              <v-col>
                <v-btn color="#7EC352" class="btn-send" v-ripple role="button" @click="sendRequest">
                  {{oracle.translate('ارسال فرم درخواست')}}
                </v-btn>
              </v-col>
            </v-container>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import oracle from "@/oracle";

export default {
  name: "contactus",
  data: () => ({
    number: null,
    name: null,
    note: null,
    title: null,
    oracle: oracle
  }), components: {},
  methods: {
    sendRequest() {
      let data = {
        "name": this.name,
        "number": this.number,
        "note": this.note,
        "title": this.title,
        "isSuggest": false,
      }
      oracle.axios("vendor/informSupport", data, this.showSuccess)
    }, showSuccess(response) {
      this.name = null
      this.number = null
      this.note = null
      this.title = null
      oracle.showSuccess('پیام شما با موفقیت ثبت شد' + '<br>' + 'لطفا منتظر تماس از سمت تیم پشتیبانی باشید!' + '\n')
    }
  }
};
</script>
<style>
.contactus {
  background: #fff;
}

.contactus .contactus-info {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
}

.contactus .item-contactus-info {
  display: flex;
  margin-bottom: 30px;
  align-items: center;
}

.contactus .info-icon .v-icon {
  width: 30px;
  height: 30px;
  background-color: #7ec352;
  text-align: center !important;
  border-radius: 3px;
  margin-top: 15px;
  color: #fff;
}

.contactus .info-text {
  margin-right: 15px;
  margin-left: 15px;
}

.contactus .info-text h5 {
  font-size: 14px;
  margin-bottom: 5px;
}

.contactus.info-text span {
  font-size: 12px;
}

.contactus .fieldProfile-contact,
.contactus .fieldArea {
  margin: 0 15px !important;
  color: #acaca8;
}

.contactus .fieldProfile-contact span {
  color: red;
  font-size: 15px;
  padding: 2px;
}

.contactus .fieldProfile-contact label {
  color: #333 !important;
  font-size: 12px;
  padding-top: 20px;
  margin-top: 5px;
}

.contactus .fieldProfile-contact {
  font-size: 12px;
}

.contactus .fieldProfile-contact .v-textarea textarea {
  padding: 5px 10px;
  font-size: 14px;
  font-weight: bold;
}

.contactus .fieldProfile-contact .v-text-field input,
.contactus .fieldProfile-contact .vpd-input-group input,
.contactus .fieldProfile-contact .v-textarea textarea {
  font-size: 12px;
  text-align: end;
}

.contactus .fieldProfile-contact
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
> .v-input__control
> .v-input__slot {
  box-shadow: none !important;
  border: 1px solid #ced4da;
  border-radius: 5px;
}

.contactus .fieldProfile-contact .v-text-field.v-text-field--solo .v-input__control {
  min-height: 40px !important;
  margin: 8px 0;
}

.contactus .contactus-form .col-lg-12,
.contactus .contactus-form .col-md-12,
.contactus .contactus-form .col-12 {
  padding: 0 !important;
}

.contactus .btn-send {
  width: fit-content !important;
  border-radius: 3px !important;
  border: none !important;
  color: #fff !important;
}
</style>
